import {
  ChangeDetectorRef,
  Component,
  ContentChildren,
  QueryList,
  ViewEncapsulation,
} from '@angular/core';
import { FieldGroupTypeConfig, FieldType, FieldWrapper } from '@ngx-formly/core';
import { FormGroup } from '@angular/forms';
import { first, last, takeUntil } from 'rxjs';
import * as _ from 'lodash';
import { LhStorageService } from '@hssa-itasia/ngx-util-core';
import { BogTourService } from '../services/bog-tour/bog-tour.service';
import { AppService } from '../app.service';
@Component({
  selector: 'custom-relates-to',
  styles: [
    `
      .thumps_up_col {
        display: flex;
        justify-content: right;
        align-items: center;
        margin-right: 10px;
      }
      .thumps_down_col {
        display: flex;
        justify-content: left;
        align-items: center;
        margin-left: 10px;
      }
      .relates_to_card {
        min-width: 135px;
        height: 125px;
        background: #ffffff;
        box-shadow: 0px 3px 6px #00000029;
        border: 1px solid #3bb4aa;
        border-radius: 6px;
        opacity: 1;
        position: relative;
        padding: 5px 5px 0px 0px;
        margin: 0 15px 0 0;
        z-index: 1;
      }
      .relates_to_icon_row {
        height: 65px;
      }
      .relatest_to_img_col {
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          height: 60px;
        }
      }
      .relates_to_label_col {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        font-size: 12px;
        letter-spacing: 0px;
        opacity: 1;
        height: 50px;
      }
      .relates_to_label_display_col {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        font-size: 15px;
        letter-spacing: 0px;
        color: #027382;
        opacity: 1;
        height: 50px;
      }
      .mainDiv {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: nowrap;
        overflow-x: auto;
        padding-bottom: 15px;
      }
      .relates_to_label {
        -webkit-box-orient: vertical;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        overflow: hidden;
        position: relative;
      }
      .relates_to_label_thums_up {
        background: #00914633;
        padding: 2px;
        border-radius: 24px;
        color: #009146 !important;
        margin-top: 10px;
      }
      .relates_to_label_thums_down {
        background: #fcccd0;
        padding: 2px;
        border-radius: 24px;
        color: #f00014 !important;
        margin-top: 10px;
      }
      .thumbs_down_selected_css {
        height: 24px;
        width: 24px;
      }

      .card_selected_css {
      }
      .thumbs_up_row {
        margin-top: 5px;
        z-index: 999;
        position: relative;
      }
      .unselect_relatesTo {
        position: relative;
      }
      .thums_up_down_size {
        height: 40px;
      }
      .cc_special_icon_col {
        width: 25px;
        max-width: 25px;
        margin: 0px;
        padding: 0px;
        margin-top: 5px;
      }
      .close_icon_relates_to {
        height: 25px;
        width: 25px;
        color: #000;
      }
    `,
  ],
  template: `
    <div class="mainDiv">
      <div *ngFor="let option of to.options; let i = index">
        <ion-card
          class="relates_to_card"
          *ngIf="option.checked == ''"
          [ngClass]="option.card_checked ? 'card_selected_css' : ''"
        >
          <ion-row class="relates_to_icon_row" (click)="onChange($event, option, '', 'select')">
            <ion-col class="relatest_to_img_col">
              <img
                *ngIf="!option.is_critical_control"
                src="assets/img/rapid-tour/relatest_to_icon/health.png"
              />
              <img
                *ngIf="option.is_critical_control"
                src="assets/img/rapid-tour/relatest_to_icon/critical_control.png"
              />
            </ion-col>
            <ion-col class="cc_special_icon_col" *ngIf="option.is_critical_control">
              <img src="assets/img/rapid-tour/relatest_to_icon/cc_shield.svg" />
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col
              class="relates_to_label_display_col"
              [ngClass]="{
                relates_to_label_thums_up: option.checked == 'Checked',
                relates_to_label_thums_down: option.checked == 'Not Checked',
              }"
            >
              <div class="relates_to_label">
                {{ option.label }}
              </div>
            </ion-col>
          </ion-row>
        </ion-card>
      </div>
    </div>

    <div *ngFor="let option of to.options; let i = index">
      <ion-row
        *ngIf="option.checked != ''"
        [ngClass]="{
          relates_to_label_thums_up: option.checked == 'Checked',
          relates_to_label_thums_down: option.checked == 'Not Checked',
        }"
      >
        <ion-col
          (click)="opencVPCQuestionarie(option)"
          size="10"
          class="ion-align-self-center relates_to_label_col"
        >
          <div class="relates_to_label">
            {{ option.label }}
          </div>
        </ion-col>
        <ion-col class="ion-align-self-center" size="2">
          <div
            (click)="onChange($event, option, '', 'unselect')"
            class="unselect_relatesTo"
            *ngIf="option.checked != ''"
          >
            <ion-icon class="close_icon_relates_to" name="close-outline"></ion-icon>
          </div>
        </ion-col>
      </ion-row>
    </div>
  `,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class CustomRelatesToFormlyType extends FieldWrapper {
  fieldGroup: FieldGroupTypeConfig;
  form_name: any;
  selected_risk: string = 'immediate_risk';
  constructor(
    private changeDetection: ChangeDetectorRef,
    private appservice: AppService,
    public bogService: BogTourService,
    private lhStorage: LhStorageService
  ) {
    super();
  }

  async ngOnInit() {
    let editObservation = await this.lhStorage.get('editObservation');
    if (
      editObservation != null ||
      (editObservation != undefined &&
        (this.appservice.appData.userInfo.h_and_s == 'YES' ||
          this.appservice.appData.userInfo.profile.toLowerCase() == 'country exco'))
    ) {
      let editObservationData = editObservation.currentObservationInfo;
      this.updateShiedlUserRelatesTo(editObservationData);
    }
    //console.log("this.to.options 202=",this.to.options);
  }

  updateShiedlUserRelatesTo(editObservationData) {
    if (editObservationData?.hazType == 'HOUSEKEEPING') {
      let editRelatesTo: any = editObservationData.relates_to;
      this.to.options.forEach((option: any) => {
        editRelatesTo.forEach((element) => {
          if (element.id == option.id) {
            option.card_checked = true;
            option.checked = 'Checked';
          }
        });
      });
    } else {
      let editRelatesTo: any = editObservationData.selectedRelatesTo;
      this.to.options.forEach((option: any) => {
        editRelatesTo.forEach((element) => {
          if (element.id == option.id) {
            option.card_checked = true;
            option.checked = 'Checked';
          }
        });
      });
    }

    this.changeDetection.detectChanges();
  }
  // cardClickBtn(event,card){
  //     // card.card_checked=!card.card_checked;
  //     // if(!card.card_checked){
  //     //     card.checked="";
  //     // }

  //     // let relatesToFinal:any={};
  //     // _.forEach(this.to.options, (r) => {
  //     //     if(r.card_checked)
  //     //         relatesToFinal[r.value] = true;
  //     //   })
  //     // this.formControl.patchValue(relatesToFinal);
  // }
  opencVPCQuestionarie(option) {
    this.onChange('', option, '', 'select');
  }
  onChange(event, option: any, checked: string, type: any) {
    if (type == 'select') {
      option.card_checked = true;
      if (this.selected_risk == 'medium_risk' || this.selected_risk == 'immediate_risk') {
        option.checked = 'Not Checked';
      } else {
        option.checked = 'Checked';
      }
    } else {
      option.card_checked = false;
      option.checked = '';
    }
    this.formControl.patchValue(this.to.options);
    this.formControl.markAsTouched();
    let currentSelect: any = option;
    let exisitngRelatesTo = this.bogService.selectedRelatesTo;
    let findIndex = exisitngRelatesTo.findIndex((obj) => obj.id == currentSelect.id);
    if (findIndex == -1) this.bogService.selectedRelatesTo.push(currentSelect);
    else this.bogService.selectedRelatesTo[findIndex] = currentSelect;

    this.bogService.relatesToSubject.next(currentSelect);
    if (event != '') event.stopPropagation();
  }
}
